import Phaser from 'phaser';
import { BootScene } from '../scenes/BootScene';
import { MenuScene } from '../scenes/MenuScene';
import { LobbyScene } from '../scenes/LobbyScene';
import { GameScene } from '../scenes/GameScene';

// Game dimensions - will be scaled to fit screen
export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;

// Tile size for maze
export const TILE_SIZE = 32;

// Player settings
export const PLAYER_SPEED = 200;
export const PLAYER_MAX_HEALTH = 100;
export const PLAYER_FART_CAPACITY = 100;
export const PLAYER_CAPACITY_REGEN = 5; // per second

// Player colors
export const PLAYER_COLORS = [
    0x4ecdc4, // Teal (default local)
    0xff6b6b, // Red
    0xfeca57, // Yellow
    0x5f27cd, // Purple
    0x00d2d3, // Cyan
    0xff9ff3, // Pink
    0x54a0ff, // Blue
    0x1dd1a1, // Green
];

// Fart settings
export const FART_COOLDOWN = 500; // ms
// Note: FART_*_COST, FART_*_DAMAGE, FART_*_STUN constants moved to utils/FartCalculations.ts

// Charged Fart settings
export const CHARGE_MIN_TIME = 200;      // ms before charging starts
export const CHARGE_MAX_TIME = 2000;     // ms to reach full charge

// Phaser configuration
export const GAME_CONFIG: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent: 'game-container',
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: '#1a1a2e',
    scale: {
        mode: Phaser.Scale.RESIZE,  // Fill viewport, camera handles what's visible
        autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { x: 0, y: 0 },
            debug: false, // Disable debug for production
        },
    },
    scene: [BootScene, MenuScene, LobbyScene, GameScene],
    input: {
        activePointers: 3,
    },
    render: {
        pixelArt: false,
        antialias: true,
    },
};
